import { createFileRoute, redirect } from '@tanstack/react-router';
import { getSessionJwt } from '@/services/auth';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // Redirect to login if not authenticated, otherwise to organisations
    if (!getSessionJwt()) {
      throw redirect({ to: '/login' });
    }
    throw redirect({ to: '/organisations' });
  },
});

